import http from '@/requests/http'

class CallbackNumber {
  static all (params) {
    return http.post('messages/callback-number/index', params)
  }
  static store (params) {
    return http.post('messages/callback-number/store', params)
  }
  static view (params) {
    return http.post('messages/callback-number/view', params)
  }
  static update (params) {
    return http.post('messages/callback-number/update', params)
  }
  static destroy (params) {
    return http.post('messages/callback-number/destroy', params)
  }
  static setCallbackNumberActive (params) {
    return http.post('messages/callback-number/set-active', params)
  }
}

export default CallbackNumber
